import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=0725d496&scoped=true&"
import script from "./ReportDetail.vue?vue&type=script&lang=js&"
export * from "./ReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=0725d496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725d496",
  null
  
)

export default component.exports